export default "__VITE_PUBLIC_ASSET__e6ef779f__"